import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';
import BasketPxDetails from './BasketPxDetailsTemplate';
import { rem } from 'polished';

export const BasketPxDetailsStyled = styled(BasketPxDetails)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey16};

    .sections {
        margin: ${rem('16px')} 0 ${rem('32px')} 0 !important;
    }

    .pxInitialize {
        min-height: unset !important;
    }

    .titleWrapperButton {
        width: 100%;
    }

    .titleWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: ${rem(43)} 0;
        width: 100%;

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textBig};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: 1.4;
        }

        svg {
            height: ${rem(14)};
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                    stroke-width: 2;
                }
            }
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .description {
        span {
            font-size: ${rem(14)};
            display: block;

            p {
                margin: unset;
                line-height: 1.67;
            }
        }

        .link {
            text-decoration: underline;
            cursor: pointer;
            background: none;
            border: none;
            padding: 0;
            font-size: ${rem('14px')};
            margin-top: ${rem('4px')};

            a {
                color: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .detailTitle {
        padding-top: ${rem(24)};
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }

    .detail {
        margin: ${rem(20)} 0;

        @media (min-width: ${breakpoints.md}px) {
            display: flex;
            justify-content: space-between;
        }

        .leftSection,
        .rightSection {
            width: 100%;

            @media (min-width: ${breakpoints.md}px) {
                width: 50%;
            }
        }

        .leftSection {
            p {
                padding-bottom: ${rem(20)};
            }

            @media (min-width: ${breakpoints.md}px) {
                margin: 0 ${rem(8)} 0 0;
            }
        }

        .rightSection {
            border-top: 1px solid ${({ theme }) => theme.colors.grey25};
            border-bottom: 1px solid ${({ theme }) => theme.colors.grey25};

            button {
                background: none;
                padding: 0;
                border: none;
                text-decoration: underline;
                cursor: pointer;
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                padding-right: ${rem(18)};
            }

            p {
                display: flex;
                justify-content: space-between;
                padding: ${rem(12)} 0 ${rem(6)} 0;
                margin: 0;
            }

            div {
                padding: ${rem(6)} 0 ${rem(12)} 0;
            }

            .value {
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }

            @media (min-width: ${breakpoints.md}px) {
                margin: 0 0 0 ${rem(8)};
            }
        }
    }

    .summary {
        display: flex;
        flex-direction: column;
        position: relative;

        .icon {
            font-size: ${rem(28)};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            display: flex;
            align-items: center;
            justify-content: center;
        }

        @media (min-width: ${breakpoints.md}px) {
            justify-content: space-between;
            flex-direction: row;
        }

        .leftSection,
        .rightSection {
            padding: ${rem(22)};
            width: 100%;
            margin: ${rem(10)} 0;
            background: ${({ theme }) => theme.colors.grey8};
            height: ${rem(140)};
            display: flex;
            flex-direction: column;

            @media (min-width: ${breakpoints.md}px) {
                width: 49%;
            }

            .summaryTitle {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }

            .summaryValue {
                padding-top: ${rem(11)};
                margin: 0;
                font-size: ${({ theme }) => theme.fontSizes.h5};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }

            .summaryDescription {
                padding-top: ${rem(8)};
                margin: 0;
                font-size: ${({ theme }) => theme.fontSizes.textTiny};
                color: #73767a;
            }
        }
    }

    .continue {
        margin: ${rem(50)} auto;
        max-width: ${rem(700)};

        .continueLabel {
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: ${rem(18)};
        }
    }

    .status {
        margin: ${rem(50)} auto;
        background: ${({ theme }) => theme.colors.grey8};
        padding: ${rem(20)};
        position: relative;
        padding-left: ${rem(80)};

        .statusIcon {
            svg {
                position: absolute;
                width: ${rem(30)};
                height: ${rem(30)};
                left: ${rem(30)};
                top: ${rem(30)};
            }
        }

        .statusLabel {
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: ${rem(18)};
        }
      
        .statusDescription {
            line-height: ${rem(18)};
        }

        .trash {
            position: relative;
            background: none;
            padding: 0;
            border: none;
            cursor: pointer;
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            text-decoration: underline;
            margin-top: ${rem(15)};
            display: flex;
            align-items: center;
            gap: ${rem(10)};

            svg {
                width: ${rem(24)};
                height: ${rem(24)};
            }
        }
    }

    .footer {
        padding: ${rem(32)} 0;

        .label {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
        }

        .description {
            font-size: ${({ theme }) => theme.fontSizes.textTiny};
            margin: ${rem(4)} 0;
        }
    }

    .universaleHrefExchangeWidget {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};

        &:hover {
            background: ${({ theme }) => theme.colors.white};
        }
    }

    .spinner {
        margin: 0 auto;
        padding: ${rem(30)} 0;
    }
`;
